<template>
  <div class="container">
    <section>
      <div class="box">
        <ul>
          <li
            class="notification is-danger"
            v-for="error in errors"
            :key="error.key"
          >
            <strong class="is-danger">{{ error.value }}</strong>
          </li>
        </ul>
        <b-field label="Email">
          <b-input type="email" icon="email" v-model="email"></b-input>
        </b-field>

        <b-field label="Benutzername">
          <b-input v-model="userName" maxlength="30"></b-input>
        </b-field>

        <b-field label="Password">
          <b-input type="password" v-model="password" password-reveal></b-input>
        </b-field>
        <b-field label="Password wiederholen">
          <b-input
            type="password"
            v-model="passwordValidation"
            password-reveal
          ></b-input>
        </b-field>

        <b-field label="Telefon">
          <b-input v-model="phone"></b-input>
        </b-field>

        <b-button type="is-primary" @click="registerUser">Anlegen</b-button>
      </div>
    </section>
  </div>
</template>

<script>
import {ToastProgrammatic as Toast} from 'buefy'
import authApi from '@/api/auth-api'
export default {
  name: 'createUser',
  data() {
    return {
      userName: null,
      email: null,
      phone: null,
      password: null,
      passwordValidation: null,
      errors: [],
    }
  },
  methods: {
    async registerUser() {
      this.errors = []
      try {
        let res = await authApi.registerUser({
          userName: this.userName,
          email: this.email,
          password: this.password,
          phone: this.phone,
        })
        if (res.success) {
          this.userName = null
          this.email = null
          this.phone = null
          this.password = null
          this.passwordValidation = null
          Toast.open('Benutzer erfolgreich angelegt.')
        } else {
          this.errors = res.errors
        }
      } catch (error) {
        if (error.response.status == 400) {
          this.errors.push({
            key: 'validation-error',
            value: 'Bitte prüfen Sie Ihre Eingaben!',
          })
          if (error.response.data) {
            this.errors.push({
              key: 'details',
              value: error.response.data.detail,
            })
          }
        }
      }
    },
  },
}
</script>
